<template>
  <div class="my-profile-tab w-100">
    <form data-vv-scope="user" @submit.prevent="handleSubmit('user')" class="d-flex flex-column" style="gap: 40px">

      <div class="profile">
        <img :src="photo || require('@/assets/img/avatar.png')" alt="logo" />
        <div class="profile-info">
          <h5>{{ userData.name }}</h5>
          <p @click="openFilePicker">{{ $t('views.seller.my_account.text_1235') }}</p>
          <input type="file" ref="fileInput" style="display: none;" accept="image/*" @change="handleFileChange" />
        </div>
      </div>

      <div class="d-flex flex-column" style="gap: 24px">
        <div class="title">
          <h5>{{ $t("views.seller.my_account.text_1159") }}</h5>
          <p>{{ $t("views.seller.my_account.text_1234") }}</p>
        </div>

        <div class="personal-data">
          <b-row>
            <b-col cols="12" md="6">
              <BaseInput id="name" label-for="name" name="name" v-model="user.name" type="text" maxlength="40"
                v-validate="'required'" :placeholder="$t('views.seller.my_account.text_1160')"
                :label="$t('views.seller.my_account.text_1569')" :isValid="!errors.has('user.name')"
                :errorMessage="$t('views.seller.my_account.text_1161')">
              </BaseInput>
            </b-col>

            <b-col cols="12" md="6">
              <BaseInput label-for="phone" id="phone" name="phone" v-model="user.cellphone" type="text"
                v-mask="['(##) ####-####', '(##) #####-####']" v-validate="'required'"
                :label="$t('views.seller.my_account.text_1570')" :placeholder="$t('views.seller.my_account.text_1571')"
                :isValid="!errors.has('user.phone')" :errorMessage="$t('views.seller.my_account.text_1572')">
              </BaseInput>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="12" md="6">
              <BaseInput label-for="cpf" id="cpf" name="cpf" v-model="user.cpf_cnpj" type="text"
                v-validate="'required|cpf_cnpj'" v-mask="['###.###.###-##']"
                :label="$t('views.seller.my_account.text_1575')" :isValid="!errors.has('user.cpf')"
                :errorMessage="$t('views.seller.my_account.text_1162')" disabled></BaseInput>
            </b-col>
            <b-col cols="12" md="6">
              <BaseInput id="rg" name="rg" v-model="user.rg" label-for="rg" type="text" v-validate="'required'"
                v-mask="['#############']" :placeholder="$t('views.seller.my_account.text_1166')"
                :label="$t('views.seller.my_account.text_1577')" :isValid="!errors.has('user.rg')"
                :errorMessage="$t('views.seller.my_account.text_1167')" disabled></BaseInput>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="12" md="6" class="d-flex flex-column" style="gap: 6px;">
              <BaseInput id="email" name="email" label-for="email" v-model="user.email" type="text"
                v-validate="'required|email'" :placeholder="$t('views.seller.my_account.text_1574')"
                :label="$t('views.seller.my_account.text_1573')" :isValid="!errors.has('user.email')"
                :errorMessage="$t('views.seller.my_account.text_1162')" :disabled="$store.getters.verifyEmail"
                :readonly="$store.getters.verifyEmail">
              </BaseInput>
              <p class="note-email mt-n2">
                {{ $t('views.seller.my_account.text_1236') }},
                <a target="_blank" href="https://faq.voompcreators.com.br/">{{ $t('views.seller.my_account.text_1237')
                  }}</a>
              </p>
            </b-col>
          </b-row>
        </div>
      </div>

      <div class="d-flex flex-column" style="gap: 16px;">
        <div class="divider" style="margin: 0;"></div>
        <b-row>
          <b-col cols="12" class="d-flex justify-content-end">
            <BaseNewButton variant="primary" icon="tick-outline" iconPosition="left" type="submit">{{
              $t("views.seller.my_account.text_1174")
              }}</BaseNewButton>
          </b-col>
        </b-row>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  name: 'MyProfileTab',
  props: {
    user: {
      type: Object
    },
    userData: {
      type: Object
    },
    statusValidation: {
      type: Object
    },
    onSubmit: {
      type: Function
    },
    userImage: {
      type: [Array, FileList]
    },
    uploadImage: {
      type: Function
    }
  },
  data() {
    return {
      newImage: null,
    };
  },
  computed: {
    photo() {
      if (this.newImage) {
        return this.newImage;
      }
      if (!this.userImage) {
        return false;
      }
      if (!this.userImage.length) {
        return false;
      }
      return this.userImage[0].path;
    }
  },
  methods: {
    handleSubmit() {
      this.$validator.validateAll('user').then((result) => {
        if (result) {
          // eslint-disable-next-line
          return this.onSubmit('user');
        }
        this.$bvToast.toast(this.$t('views.seller.my_account.text_1199'), {
          title: this.$t('views.seller.my_account.text_1198'),
          variant: 'danger',
          autoHideDelay: 5000,
          appendToast: true,
        });
      });
    },
    openFilePicker() {
      this.$refs.fileInput.click();
    },
    handleFileChange(event) {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();

        reader.onload = (e) => {
          this.newImage = e.target.result;

          this.uploadImage(null, null, [{
            path: e.target.result,
            name: file.name
          }]);
        };

        reader.readAsDataURL(file);
      }
    },
  }
};
</script>

<style scoped>
.my-profile-tab {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.personal-data {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.profile {
  display: flex;
  gap: 16px;
  align-items: center;
}

.profile h5 {
  color: var(--Default-gray-900, #111827);
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  margin: 0;
}

.profile-info p {
  color: var(--Default-primary-800, #0854C5) !important;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  cursor: pointer;
}

.profile img {
  width: 80px;
  height: 80px;
  border-radius: 50px;
}

.note-email a {
  color: var(--Default-primary-800, #0854C5);
  font-weight: 400;
  line-height: 20px;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
}
</style>
